import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { FunctionalityEnumClient } from '@frontend/functionality/api';
import { FunctionalityType } from '@frontend/functionality/types';
import React, { useEffect, useState } from 'react';

const ID = 'functionality-type-select';
export interface FunctionalityTypeSelectProps extends Omit<SelectInputV2Props<FunctionalityType>, 'options'> {
    subset?: string[];
}

export const FunctionalityTypeSelect = (props: FunctionalityTypeSelectProps) => {
    const [options, setOptions] = useState<{ label: string; value: string }[]>([]);

    useEffect(() => {
        const fetchOptions = async () => {
            const types = await FunctionalityEnumClient.fetchFunctionalityTypes();
            setOptions(types.map((c) => ({ label: c.replace(/_/g, ' '), value: c })));
        };
        fetchOptions();
    }, []);

    return (
        <SelectInputV2
            {...props}
            id={ID + props.id}
            label={props.label || 'Functionality Type'}
            options={props.subset ? props.subset.map((s) => ({ value: s, label: s })) : options}
        />
    );
};
